import { InjectionToken } from '@angular/core';

export const CLEAR_STORAGE_KEYS_AFTER_LOGOUT: InjectionToken<string[]> = new InjectionToken<string[]>(
  'Storage keys to remove after logout'
);
